module.exports = __webpack_public_path__ + "media/application/images/blobs/blob_blue-618e6dfa7b7201698a1aa3a291b9a1c3.png";